import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import history from "../../auth/history";
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import tokenErrorHandler from "../tokenErrorHandler";
// import { setLoginResponse, setToken } from "../../redux/login/login.action";
import { resetMiscData, setBankLogoList, setDeviceInfo, setLoginTimestamp, setSavedOtpDetails } from "../../redux/misc-data/misc-data.action";
import '../BillPayComponent/billPayy.css';
const httpClient = axios.create();

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
            password: '',
            message: '',
            resetPartner: '',
            userIdErrMsg:''
        }
    }

    componentDidMount() {
        var resetPasswordRedirectPartner = process.env.REACT_APP_PARTNER;

        this.setState({
            resetPartner: resetPasswordRedirectPartner
        })

    }
    componentWillUnmount() {
    }

    checkValidation() {
        {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.emailId)) {
                return (true)
            }
            alert("You have entered an invalid email address!")
            return (false)
        }
    }

    enterUserId = (e) => {
        e.preventDefault();
        this.setState({
            userId: e.target.value,
            userIdErrMsg:''
        })
    }

    resetPassword = (event) => {
        event.preventDefault();
        //service for rest password and back to login page
    }

    generateOtp = (event) => {

        event.preventDefault();
        this.setState({
            errMsg: '',
            userIdErrMsg:''
        })
        if (this.state.userId != '') {
            var url = '/api/v1/retailer/reset/' + this.state.userId;
            httpClient.get(url,'',
            ).then((response) => {
                console.log('reset otp response' + JSON.stringify(response.data));
                if (response.data.response.msg == 'SUCCESS') {
                    store.dispatch(setSavedOtpDetails(response.data.otpDetails));
                    var gotoResetPasswordPage=document.getElementById('gotoResetPasswordPage');
                    gotoResetPasswordPage.click();

                } else {
                    this.setState({
                        errMsg: response.data.displayMsg
                    })
                }
            }).catch(error => {
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {
                    this.setState({
                        errMsg: 'Something went wrong!'
                    })
                }
                console.log(error.message);
            });
        } else {
            this.setState({
                userIdErrMsg: 'Please enter user Id'
            })
        }
    }

    render() {
        return (
            <div>
                <div class="login-container">
                    <div class="container-fluid">
                        <div class="row justify-content-center">
                            <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                                <div class="login-box">
                                    <div class="login-head">
                                        
                                        {this.state.resetPartner == 'cms' &&

                                            <center>
                                                <div class='cms-logo'></div>
                                            </center>
                                        }
                                        {this.state.resetPartner == 'finxpay' &&
                                            <img src="images/finxpay.png" alt="finXpay" class="img-fluid"></img>
                                        }
                                        <p>Send OTP</p>
                                    </div>
                                    <Link to='/reset-password'>
                                        <button id="gotoResetPasswordPage" hidden={true}></button>
                                    </Link>

                                    <div class="resetForm" id="amtbox1">
                                        <center>
                                            <form onSubmit={this.generateOtp}>
                                                <div class="form-floating">
                                                    <input type="text" class="form-control" id="emailid" placeholder="User ID"
                                                        onChange={this.enterUserId}  />
                                                    <label for="emailid">User ID</label>
                                                    {this.state.userIdErrMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.userIdErrMsg}
                                                        </div>}
                                                </div>
                                                
                                                <div class="login-form">
                                                    <button class="button" type="submit">Send OTP</button>
                                                    {this.state.errMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.errMsg}
                                                        </div>}
                                                </div>

                                            </form>
                                        </center>
                                    </div>
                                    
                                    <div class="login-form">

                                        <div class="md-form">
                                        </div>
                                        <p><a href={"/" + this.state.resetPartner + "-login"}>Back to Login?</a></p>

                                    </div>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="logcopy">Copyright &copy; 2022 All rights reserved. <br />Powered by <a href="https://www.finxpay.co.in/" target="_blank">Uvva Infotech Pvt. Ltd.</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone,callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone,callBackUrl
});

export default connect(mapStateToProps, null)(ResetPassword);
